// components/settings/ProfileSection.jsx
import { ArrowLeftToLineIcon } from "lucide-react";
import AccountStatusCard from "./AccountStatusCard";
import { getTimeElapsed } from "../../utils/timeUtils";
import Typography from "../../components/Typography/Typography";
import Button from "../../components/Button/Button";
import { GoogleIcon } from "../../Icons/GoogleIcon";

const ProfileSection = ({ loading, userData, userSubData, logout, handleUpgradeClick }) => {
  // Helper function to add two hours to the displayed time elapsed text
  const getAdjustedTimeElapsed = (dateString) => {
    if (!dateString) return "";

    // Use the original getTimeElapsed function
    const originalText = getTimeElapsed(dateString);

    // Parse the original time value
    const numberMatch = originalText.match(/^(\d+)/);
    if (!numberMatch) return originalText;

    const originalNumber = parseInt(numberMatch[1], 10);

    // Add two hours if the time unit is "ore" (hours)
    if (originalText.includes('ora') || originalText.includes('ore')) {
      const newHours = originalNumber - 2;
      return `${newHours} ${newHours === 1 ? 'ora' : 'ore'} fa`;
    }

    return originalText;
  };

  if (loading) {
    return (
      <div className="flex flex-col gap-4 w-full">
        <div className="bg-gray-100 animate-pulse rounded-[8px] w-full h-36" />
        <div className="bg-gray-100 animate-pulse rounded-[8px] w-full h-36" />
      </div>
    );
  }

  return (
    <div className="flex w-full flex-col items-end gap-9">
      <div className="flex w-full flex-col gap-4">
        <Typography size="20" weight="sb">Il tuo profilo</Typography>
        {userData ? (
          <div className="w-full border-[2px] border-gray-150 bg-white rounded-[12px] px-6 py-5 flex justify-between items-center">
            <div className="flex flex-col gap-1">
              <Typography size="24" weight="md">{userData.FirstName} {userData.LastName}</Typography>
              <Typography size="16" weight="md" color="gray-600">{userData.Email}</Typography>
            </div>
            {userData.IsGoogleUser && (
              <GoogleIcon size={24} />
            )}
          </div>
        ) : (
          <div className="w-full border-[2px] border-gray-150 bg-white rounded-[12px] px-6 py-5 flex flex-col gap-1">
            <Typography size="16" color="gray-600">Nessun dato utente disponibile</Typography>
          </div>
        )}
      </div>
      <div className="flex w-full flex-col gap-4">
        <AccountStatusCard userData={userSubData} handleUpgradeClick={handleUpgradeClick} />
        <div className="w-full flex flex-col md:flex-row md:justify-between text-gray-600">
          {(() => {
            const adjustedTime = userData?.CreationDate ? getAdjustedTimeElapsed(userData.CreationDate) : "";
            console.log(adjustedTime);
            return (
              <>
                <tt>Utente creato {adjustedTime}</tt>
                <tt>BETA Version Number 0.2.9</tt>
              </>
            );
          })()}
        </div>

      </div>
      <Button size="md" text="Logout" type="error" onClick={logout} licon={<ArrowLeftToLineIcon size={20} color="red" />} />
    </div>
  );
};

export default ProfileSection;